import svg4everybody from 'svg4everybody';
svg4everybody();

import './partials/LazyLoad';
import './partials/SmoothScroll';


// WEBPACK FOOTER //
// ./resources/js/index.js